import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { id: 'services', label: 'Leistungen' },
    { id: 'netzwerk', label: 'Netzwerk' },
    { id: 'about', label: 'Über uns' },
    { id: 'referenzen', label: 'Referenzen' },
    { id: 'faq', label: 'FAQ' },
    { id: 'contact', label: 'Kontakt' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-3'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => scrollToSection('hero')}
          >
            <div className="bg-white rounded-lg shadow-md p-2 transition-all duration-300 group-hover:shadow-lg">
              <img 
                src="https://customer-assets.emergentagent.com/job_a2b-facility/artifacts/4frauqel_AtoBObjektservice.png" 
                alt="AtoB Objektservice Logo" 
                className="h-12 md:h-14 lg:h-16 w-auto object-contain"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map(item => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-atob-orange font-medium transition-colors duration-200"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-atob-orange hover:bg-atob-orange/90 text-white"
            >
              <Phone className="mr-2 h-4 w-4" />
              Jetzt Kontakt aufnehmen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-gray-700 hover:text-atob-orange transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col space-y-3">
              {navItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-gray-700 hover:text-atob-orange font-medium transition-colors duration-200 text-left py-2"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-atob-orange hover:bg-atob-orange/90 text-white w-full mt-4"
              >
                <Phone className="mr-2 h-4 w-4" />
                Jetzt Kontakt aufnehmen
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
